module.exports = __webpack_public_path__ + "static/media/payment.65060d66.svg";